import type { FeedbackInput } from '../housien-models/FeedbackInput';
import type { SuccessResponse } from '../housien-models/SuccessResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

/**
 * OpenAPI client for in-app feedback (suggestions, bugs, complaints).
 */
export class FeedbackService {
  /**
   * Submit feedback from an authenticated user.
   * @param requestBody Feedback payload (type, message, category required).
   * @returns Success acknowledgement from the API.
   */
  public static submitFeedback(requestBody: FeedbackInput): CancelablePromise<SuccessResponse> {
    return __request(OpenAPIHousien, {
      method: 'POST',
      url: '/feedback',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
